import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useInterval } from '../../../utility/customHooks/useInterval';

export default function CountdownTimer(props) {

  const { initialMinute, initialSeconds = 0, onTimerComplete = null } = props;

  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);

  useInterval(() => {
    if (seconds > 0) {
      setSeconds(prevSec => prevSec - 1);
    }

    if (seconds === 0) {
      if (minutes === 0) {

        if (onTimerComplete) {
          onTimerComplete();
        }
      }
      else {
        setMinutes(prevMin => prevMin - 1);
        setSeconds(59);
      }
    }
  }, 1000);

  return (
    <React.Fragment>
      {(minutes === 0 && seconds === 0) ? null
        : <h4 className="pb-4 pt-2"> {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h4>
      }
    </React.Fragment>
  )
}

CountdownTimer.propTypes = {
  initialMinute: PropTypes.number.isRequired,
  initialSeconds: PropTypes.number,
  onTimerComplete: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Time/CountdownTimer.js